const buildPFVehicleOwner = (data) => {
  const {
    address: { countyId, cityId, ...restAddress },
    driverLicenceDate,
    idExpirationDate,
    ...restData
  } = data;

  return {
    ...restData,
    address: {
      ...restAddress,
      addressType: "HOME",
      countryId: 185,
      countyId: Number(countyId),
      cityId: Number(cityId),
      foreignCountyName: "",
      foreignCityName: "",
      streetTypeId: 41,
    },
    legalType: "PF",
    idType: "CI",
    idExpirationDate: `${idExpirationDate}-01-01T00:00:00`,
    driverLicenceDate: `${driverLicenceDate}-01-01T00:00:00`,
  };
};

export const buildPJVehicleOwner = (data) => {
  const { address, ...restData } = data;
  return {
    legalType: "PJ",
    ...restData,
    companyTypeId: Number(restData.companyTypeId),

    address: {
      ...address,
      addressType: "HOME",
      countryId: 185,
      countyId: Number(address.countyId),
      cityId: Number(address.cityId),
      streetTypeId: 41,
    },
  };
};

const buildVehicleDriverPayload = ({ formValues }) => {
  const {
    legalType,
    mainDriverSection: { mainDriver, mainDriverData },
    userDataSection: {
      address, // not used in driver payload
      idExpirationDate,
      driverLicenceDate,
      ...restUserDataSection
    },
  } = formValues;

  if (legalType === "PF" && mainDriver === "owner") {
    return {
      ...restUserDataSection,
      legalType: "PF",
      idType: "CI",
      idExpirationDate: `${idExpirationDate}-01-01T00:00:00`,
      driverLicenceDate: `${driverLicenceDate}-01-01T00:00:00`,
    };
  }

  if ((legalType === "PF" && mainDriver === "other") || legalType === "PJ") {
    return {
      ...mainDriverData,
      legalType: "PF",
      idType: "CI",
      idExpirationDate: `${mainDriverData.idExpirationDate}-01-01T00:00:00`,
      driverLicenceDate: `${mainDriverData.driverLicenceDate}-01-01T00:00:00`,
    };
  }
};

const buildVehicleUserPayload = ({ formValues }) => {
  const {
    legalType,
    companyDataSection: {
      companyTypeId,
      address: companyAddress,
      ...restCompanyDataSection
    },
    userDataSection: { address: userAddress, ...restUserDataSection },
  } = formValues;

  if (legalType === "PF") {
    return {
      ...restUserDataSection,

      legalType: "PF",
      idType: "CI",
      idExpirationDate: `${restUserDataSection.idExpirationDate}-01-01T00:00:00`,
      driverLicenceDate: `${restUserDataSection.driverLicenceDate}-01-01T00:00:00`,
      address: {
        ...userAddress,
        addressType: "HOME",
        countryId: 185,
        countyId: Number(userAddress.countyId),
        cityId: Number(userAddress.cityId),
        foreignCountyName: "",
        foreignCityName: "",
        streetTypeId: 41,
      },
    };
  }

  if (legalType === "PJ") {
    return {
      ...restCompanyDataSection,
      legalType: "PJ",
      companyTypeId: Number(companyTypeId),
      address: {
        ...companyAddress,
        addressType: "HOME",
        countryId: 185,
        countyId: Number(companyAddress.countyId),
        cityId: Number(companyAddress.cityId),
        foreignCountyName: "",
        foreignCityName: "",
        streetTypeId: 41,
      },
    };
  }
};

export const buildVehicleOwnerPayload = ({ formValues, leasingCompany }) => {
  if (formValues.isLeasing === "true" && leasingCompany) {
    return buildLeasingOwner(leasingCompany);
  }

  return formValues.legalType === "PF"
    ? buildPFVehicleOwner(formValues.userDataSection)
    : buildPJVehicleOwner(formValues.companyDataSection);
};

export const buildOwnerSectionPayload = ({ formValues, leasingCompany }) => {
  return {
    vehicleOwner: buildVehicleOwnerPayload({
      formValues,
      leasingCompany,
    }),
    vehicleUser: buildVehicleUserPayload({ formValues }),

    vehicleDriver: buildVehicleDriverPayload({ formValues }),
  };
};

export const buildLeasingOwner = (leasingCompany) => {
  const {
    legalType,
    companyName,
    caenCode,
    companyTypeId,
    email,
    phoneNumber,
    cif,
    countryId,
    cityId,
    countyId,
    postalCode,
    streetTypeId,
    addressType,
    foreignCountyName,
    foreignCityName,
    streetName,
  } = leasingCompany;

  return {
    legalType,
    companyName,
    caenCode,
    companyTypeId,
    email,
    phone: phoneNumber,
    cif,
    address: {
      addressType: addressType || "HOME",
      countryId: countryId || 185,
      countyId,
      cityId,
      streetName,
      postalCode,
      foreignCountyName,
      foreignCityName,
      streetTypeId,
    },
  };
};

export const getYearFromDateString = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date.getFullYear())) {
    return "";
  }

  return date.getFullYear().toString();
};
